/**
 * Limpia caracteres problemáticos del XML antes del procesamiento.
 */
export function limpiarBasuraXml(xml) {
  return xml
    .replace(/\u200B/g, '') // Zero-width space
    .replace(/\uFEFF/g, '') // BOM invisibles
    .replace(/\u00A0/g, ' ') // Espacios no rompibles
    .replace(/&nbsp;/g, ' ')
}
